import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ChallengeSuccess } from './challenge-screen.interface';

export class ChallengeScreenError extends Error {
  statusText!: string;
  urlInAKamaiEvent!: string;
  doNotProcess!: string;
  error!: [];
  constructor(
    statusText: string,
    urlInAKamaiEvent: string,
    doNotProcess: string,
    error: []
  ) {
    super();
    this.statusText = statusText;
    this.urlInAKamaiEvent = urlInAKamaiEvent;
    this.doNotProcess = doNotProcess;
    this.error = error;
  }
}
@Injectable({
  providedIn: 'root'
})
export class ChallengeSuccessService {
  _callBackAfterSuccessChallenge$ = new BehaviorSubject<ChallengeSuccess>({});

  resetValues() {
    this._callBackAfterSuccessChallenge$.next({});
  }
}
